import {
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip,
} from 'chart.js';
import React from 'react';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, Tooltip, Legend, LineElement, Title);

interface ChartProps {
    title: string;
    xdata: string[];
    ydata: number[];
}
export const KpiChart: React.FunctionComponent<ChartProps> = (props: ChartProps) => {
    const { title, xdata, ydata } = props;
    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top' as const,
            },
            title: {
                display: true,
                text: title,
            },
        },
    };
    const data = {
        labels: xdata,
        datasets: [
            {
                label: title,
                data: ydata,
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
                fill: true,
                tension: 0.1,
                hoverBorderColor: 'teal',
            },
        ],
    };

    return <Line options={options} data={data} />;
};
